import React from "react";
import { PropTypes } from 'prop-types';
import {
  InputWrapperDrop,
  NoResultsWrap,
  SelectOptionWrapper,
  SelectOptionMainWrapper
} from "../../Step1Setup/styles";
import { Select, Form } from "antd";
import { SelectWrap } from "./styles";
import { TitleWrapperFont } from "../styles";
import { SelectdropwownStyles, FormItemWrapper } from "../../Step1Setup/styles";
import { MarginSpecific } from "./styles";
import { basicImports } from "../../DefaultPropTypes";

const SelectComponent = props => {
  const { getFieldDecorator } = props.form;
  return (
    <div>
      <FormItemWrapper
        colon={false}
        label={
          props.title === "State" ? (
            <TitleWrapperFont>{props.title}</TitleWrapperFont>
          ) : (
            <MarginSpecific marginTop="16px">
              <TitleWrapperFont>{props.title}</TitleWrapperFont>
            </MarginSpecific>
          )
        }
      >
        {getFieldDecorator(`${props.id}select` , {
          rules: [
            {
              type: "string"
            }
          ]
        })(
          <InputWrapperDrop>
            <SelectOptionMainWrapper>
              <SelectWrap>
                <SelectdropwownStyles>
                  <div id={props.id} style={{ position: "relative" }}>
                    <Select
                      disabled={props.disabled ? props.disabled : false}
                      onBlur={props.handleBlur}
                      role={false}
                      showArrow={props.showArrow}
                      data-test={props.dataTest ? props.dataTest : null}
                      getPopupContainer={() =>
                        document.getElementById(props.id)
                      }
                      defaultActiveFirstOption={false}
                      notFoundContent={
                        <NoResultsWrap>No results</NoResultsWrap>
                      }
                      showSearch
                      placeholder={props.placeholder}
                      onSelect={props.handleInputChange}
                      value={
                        props.value !== "" || props.value
                          ? props.value
                          : undefined
                      }
                    >
                      {props.data.map((freq,iteration) => (
                        <Select.Option
                          key={iteration+1}
                          value={props.id === "contribute" ? freq : freq.desc}
                        >
                          <SelectOptionWrapper>
                            {props.id === "contribute" ? freq : freq.desc}
                          </SelectOptionWrapper>
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </SelectdropwownStyles>
              </SelectWrap>
            </SelectOptionMainWrapper>
          </InputWrapperDrop>
        )}
      </FormItemWrapper>
    </div>
  );
};

const WrappedSelectComponent = Form.create({ name: "select" })(SelectComponent);

SelectComponent.propTypes = {
  data: basicImports,
  form: PropTypes.object,
  handleFocusIn: PropTypes.func,
  handleInputChange: PropTypes.func,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  showArrow: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string,
};

export default WrappedSelectComponent;
